import React from 'react';
import './styles.css';
export default ({ checked, label, onCheck }) => {
    return (
        <div className={checked ? 'checkbox checked' : 'checkbox'}>
            <input
                type="checkbox"
                id={'checkbox-' + label}
                checked={checked}
                onChange={onCheck}
            />
            <label htmlFor={'checkbox-' + label}>
                <div className="checkbox-box"></div>
                <span>{label}</span>
            </label>
        </div>
    );
};
